export const deleteQuestion = (payload?: any) => ({
    type: "@saga/DELETE_QUESTION",
    payload
});

